/**
 * @module Theme
 */

import { Component, Input, OnInit } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-layout-background-color',
  templateUrl: './theme-option-layout-background-color.component.html',
  styleUrls: ['./theme-option-layout-background-color.component.css']
})
export class ThemeOptionLayoutBackgroundColorComponent implements OnInit {

  @Input() themeOptions: ThemeOptionsClass;

  showDetails: boolean;
  color = ItemColor('themes');
  opacity: number;
  backgroundColor: string;
  optionType: ThemeOptionType = 'layout_backgroundColor';

  constructor() {}

  receiveShowDetails(showDetails: boolean) {
    this.showDetails = showDetails;
  }

  ngOnInit() {
    this.backgroundColor = this.themeOptions.options().layout['backgroundColor'].toString().slice(0, 7);
    this.opacity = Math.round(parseInt(this.themeOptions.options().layout['backgroundColor'].toString().slice(7, 9), 16) * 100 / 255);
  }
  
  receiveValue(value: string) {
    this.backgroundColor = value;
    this.themeOptions.setOption(this.optionType, value + Math.round(this.opacity * 255 / 100).toString(16));
  }

  receiveOpacity(value: number) {
    this.opacity = value;
    if(this.opacity > 0) {
      this.themeOptions.setOption(this.optionType, this.backgroundColor + Math.round(value * 255 / 100).toString(16));
    }
    else {
      this.themeOptions.setOption(this.optionType, this.backgroundColor + '00');
    }
  }

}
